module.exports = {"513431100":"新城镇","513431101":"城北镇","513431102":"竹核镇","513431103":"谷曲镇","513431104":"比尔镇","513431105":"解放沟镇","513431106":"三岔河镇","513431107":"四开镇","513431108":"地莫镇","513431109":"古里镇","513431110":"俄尔镇","513431205":"美甘乡","513431210":"博洛乡","513431227":"特布洛乡","513431228":"庆恒乡","513431231":"补约乡","513431234":"金曲乡","513431238":"则普乡","513431244":"日哈乡","513431245":"哈甘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513431.json
// module id = 2572
// module chunks = 0